/* Internal Seller (pode criar bilhetes e vender através do link)
External Seller (só pode vender através do link)
Hotel/ Travel agency (pode criar bilhetes e vender através do link)
Driver (pode criar bilhetes) */

export const ResellerRoles = {
    driver: 'Driver',
    internalSeller: 'Internal Seller',
    hotel: 'Hotel/ Travel agency',
    externalSeller: 'External Seller'
}